import { addHandlerClickOnCompareIcon } from '../compare';

const initScripts = () => {
  window.initTabs();
  window.initTabCharacteristics();
  window.lazyUpdate();
  window.initSets();
  window.initBuyScript();
  window.addHandlerClickOnFavoriteIcon();
  addHandlerClickOnCompareIcon();
  window.initProductMainSlider();
  window.initProductSliderNew();
  window.attachedFilesInit();
  window.attachFilesInit();
  window.fullScreenViewer();
  window.initAjaxLoadingTabs();
  window.initVariables();
  window.initFetchVariables();
  window.initSelectVariables();
  window.initAccessoriesBlock();
};

const getHTMLFromString = (rawHTML) => {
  const htmlWrapper = document.createElement('div');
  htmlWrapper.innerHTML = rawHTML;

  return htmlWrapper.querySelector('.page');
};

const rerenderPage = (newPageContentRaw) => {
  const pageWrapper = document.querySelector('.page');
  const newPageContent = getHTMLFromString(newPageContentRaw);

  if (pageWrapper) {
    pageWrapper.replaceWith(newPageContent);
    initScripts();
  }
};

const linkClickHandler = async (evt) => {
  evt.preventDefault();

  window.loaderShow('.page');

  const target = evt.target.href
    ? evt.target
    : evt.target.closest('.variables-link');

  try {
    const rawResponse = await fetch(target.href, {
      method: 'get',
    });

    const response = await rawResponse.text();
    if (response) {
      rerenderPage(response);
      window.history.pushState({
        productHTML: response,
        href: window.location.href,
      }, 'changedVariable', target.href);
    }
  } catch (err) {
    window.loaderHide('.page');
  }
};

const saveNativePage = () => {
  const page = document.querySelector('.page');
  const pageString = page.parentNode.innerHTML;

  window.history.replaceState({
    productHTML: pageString,
    href: window.location.href,
  }, 'changedVariable', window.location.href);
};

const init = () => {
  const variablesLinks = document.querySelectorAll('.variables-link');

  variablesLinks.forEach((link) => {
    link.addEventListener('click', linkClickHandler);
  });

  window.addEventListener('popstate', (history) => {
    if (history.state.productHTML) {
      rerenderPage(history.state.productHTML);
    }
  });
};

window.initFetchVariables = init;

saveNativePage();
init();
